<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="log-box">
    <el-dialog :before-close="onCloseDialog" :visible="true">
      <el-table :data="list" style="width: 100%" height="250">
        <el-table-column fixed prop="admin_name" label="操作人">
        </el-table-column>
        <el-table-column prop="create_time" label="操作时间"> </el-table-column>
        <el-table-column prop="work_id" label="工单id"> </el-table-column>
        <el-table-column prop="action" label="操作内容"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    work_id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      fullscreenLoading: false,
      list: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/Work/getWorkLog", {
          work_id: this.work_id,
        })
        .then(result => {
          this.fullscreenLoading = false;
          if (result.data.code != 200) {
            return this.$message.error(result.data.msg);
          }
          this.list = result.data.data;
        })
        .catch(err => {});
    },
    onCloseDialog() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/work/components/WorkLog.vue